import React, { useState, useEffect } from 'react';
import "./ChangeManagement.css"
import SalesTologyFooter from '../SalesTologyFooter/SalesTologyFooter';
import Navbar from '../Navbar/Navbar';
import image7 from '../../assests/salestology-img07-1024x683.webp'

// Change Management Component
const ChangeManagement = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Navbar />
      <div className="service-container" style={{ marginTop: '80px' }}>
        <div className="service-header">Change Management</div>
        <div className={`service-content ${isVisible ? 'visible' : ''}`}>
          <div className="service-image">
            <img src={image7} alt="Change Management" />
          </div>
          
          <div className="service-text">
            <h2 className="service-title">Change Management And Capability Adoption</h2>
            
            <p className="service-description">
              We integrate change management in the transformation journey map from the start. This means that leadership buy-in is in the forefront of the implementation plan. Before embarking on execution or even planning for change, the leaders must be brought in and given agency. Their ability to embrace and lead the change will ultimately determine the success or failure of the change effort.
            </p>
            
            <p className="service-description">
              We follow a proven change management methodology that ensures the human element is front and center. We believe that no process or technology can be effectively implemented or adopted unless thoughtful consideration is given to change management.
            </p>
            
            <p className="service-description">Our process does just that!</p>
          </div>
        </div>
      </div>
      <SalesTologyFooter />
    </>
  );
};

export default ChangeManagement;